import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["measurementInput", "destroyInput"];

  handleMeasurementChange() {
    const value = parseFloat(this.measurementInputTarget.value) || 0;

    this.destroyInputTarget.value = value === 0 ? "1" : "0";
  }
}
